import { useNavigate } from "react-router-dom";
import { DataTable } from "@/components/ds";
import type { BookPermission } from "@/hooks/usePermissions";
import styles from "@/pages/dashboard.module.sass";

/** List of a borrower's readable books — used as the multi-book landing
 * and as the "My Facilities" empty-state fallback when there are no facilities yet. */
export function BorrowerBookList({ books }: { books: BookPermission[] }) {
  const navigate = useNavigate();
  return (
    <DataTable
      columns={[
        { key: "book", label: "Book", sortable: false },
        { key: "chevron", label: "", sortable: false, align: "right" as const },
      ]}
      data={books.map((b) => ({
        book: <span className={styles.facilityName}>{b.bookName ?? "Book"}</span>,
        chevron: <span className={styles.chevron}>›</span>,
      }))}
      onRowClick={(_row, i) => navigate(`/books/${books[i].bookId}`)}
      emptyMessage="No books."
    />
  );
}
